import { apiGet, apiPost, apiPut } from '@/api/http';

import type { Seniority } from '@/types/reference';

const api_url = import.meta.env.VITE_API_URL;

export const getSeniorityList = () =>
  apiGet<Seniority[]>(`${api_url}seniority/`);

export const createSeniority = (name: string) =>
  apiPost<Seniority>(`${api_url}seniority/`, { name });

export const setSeniorityList = (seniorityIds: string[]) =>
  apiPut(`${api_url}recruiters/me/seniority/`, {
    seniority: seniorityIds,
  });
